'use client';
import AppLayout from '../../layouts/AppLayout/AppLayout';

const Terms = () => {
  return (
    <AppLayout>
      <div className="p-6">
        <h1 className="mb-4 text-3xl font-semibold">TERMS AND CONDITIONS</h1>
        <p className="mb-6 text-sm text-textSecondary">
          Last Updated 16 February 2026
        </p>
        <section>
          <h2 className="mb-2 text-xl font-semibold">
            AGREEMENT TO OUR LEGAL TERMS
          </h2>
          <p>
            We are factiii limited liability company (&quot;Company,&quot;
            &quot;we,&quot; &quot;us,&quot; &quot;our&quot;), a company
            registered in San Antonio, TX 78254. We operate the website
            <span className="text-primary">
              <a
                href={process.env.NEXT_PUBLIC_SITE_URL}
                className="hover:underline"
              >
                {process.env.NEXT_PUBLIC_SITE_URL}
              </a>
            </span>
            , the mobile application factiii (the &quot;App&quot;), and related
            products and services that refer to these legal terms (collectively,
            the &quot;Services&quot;).
          </p>
          <p>
            Factiii aims to become the world&apos;s most trusted source of
            information, allowing users to create their own content and
            providing tools to enable research. We offer premium tools for
            faster searches and enhanced privacy.
          </p>
          <p>
            Contact us by email at
            <span className="text-primary">
              <a href="mailto:support@factiii.com" className="hover:underline">
                support@factiii.com
              </a>
            </span>
            .
          </p>
          <p>
            By accessing the Services, you agree to be bound by these Legal
            Terms. If you do not agree, discontinue use immediately.
          </p>
          <p>
            We will notify you of any changes to the Services. Changes to Legal
            Terms will become effective seven (7) days after notice. Immediate
            changes apply to court orders, bug fixes, security updates, and new
            functionality. Continuing to use the Services after the effective
            date of changes means you agree to the modified terms. If you
            disagree, you may terminate the Services as per the section{' '}
            <span className="text-primary">
              <a href="#19" className="hover:underline">
                &quot;TERM AND TERMINATION.&quot;
              </a>
            </span>
          </p>
          <p>
            Minors must have permission from and be supervised by their parent
            or guardian to use the Services.
          </p>
          <p>
            We recommend printing a copy of these Legal Terms for your records.
          </p>
        </section>

        <div className="my-6 rounded-md p-4 shadow-md">
          <h2 className="mb-4 text-xl font-semibold">Table of Contents</h2>
          <div className="space-y-2">
            {[
              '1. OUR SERVICES',
              '2. INTELLECTUAL PROPERTY RIGHTS',
              '3. USER REPRESENTATIONS',
              '4. USER REGISTRATION',
              '5. PRODUCTS',
              '6. PURCHASES AND PAYMENT',
              '7. RETURN/REFUNDS POLICY',
              '8. PROHIBITED ACTIVITIES',
              '9. USER GENERATED CONTRIBUTIONS',
              '10. CONTRIBUTION LICENSE',
              '11. GUIDELINES FOR REVIEWS',
              '12. MOBILE APPLICATION LICENSE',
              '13. SOCIAL MEDIA',
              '14. THIRD-PARTY WEBSITES AND CONTENT',
              '15. ADVERTISERS',
              '16. SERVICES MANAGEMENT',
              '17. PRIVACY POLICY',
              '18. COPYRIGHT INFRINGEMENTS',
              '19. TERM AND TERMINATION',
              '20. MODIFICATIONS AND INTERRUPTIONS',
              '21. GOVERNING LAW',
              '22. DISPUTE RESOLUTION',
              '23. CORRECTIONS',
              '24. DISCLAIMER',
              '25. LIMITATIONS OF LIABILITY',
              '26. INDEMNIFICATION',
              '27. USER DATA',
              '28. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES',
              '29. CALIFORNIA USERS AND RESIDENTS',
              '30. MISCELLANEOUS',
              '31. CONTACT US'
            ].map((item, index) => (
              <div key={item}>
                <span className="text-primary">
                  <a href={`#${index + 1}`} className="hover:underline">
                    {item}
                  </a>
                </span>
              </div>
            ))}
          </div>
        </div>

        <section>
          <h1 id="1" className="mb-2 text-xl font-semibold">
            1. OUR SERVICES
          </h1>
          <p>
            The information provided when using the Services is not intended for
            distribution to or use by any person or entity in any jurisdiction
            where such distribution or use would be contrary to law or
            regulation or which would subject us to any registration
            requirement. Users accessing the Services from other locations do so
            on their own initiative and are responsible for compliance with
            local laws.
          </p>
          <p>
            The Services are not tailored to comply with industry-specific
            regulations (HIPAA, FISMA, etc.). You may not use the Services in a
            way that would violate the Gramm-Leach-Bliley Act (GLBA).
          </p>

          <h1 id="2" className="mb-2 text-xl font-semibold">
            2. INTELLECTUAL PROPERTY RIGHTS
          </h1>
          <h3 className="mb-2 text-lg font-semibold">
            Our intellectual property
          </h3>
          <p>
            We are the owner or licensee of all intellectual property rights in
            our Services, including source code, databases, functionality,
            software, website designs, audio, video, text, photographs,
            graphics, trademarks, service marks, and logos.
          </p>
          <p>
            Our Content and Marks are protected by copyright and trademark laws
            and treaties around the world. The Content and Marks are provided
            &quot;AS IS&quot; for your personal, non-commercial use or internal
            business purpose only.
          </p>

          <h3 className="mb-2 text-lg font-semibold">
            Your use of our Services
          </h3>
          <p>
            Subject to your compliance with these Legal Terms, we grant you a
            non-exclusive, non-transferable, revocable license to access the
            Services and download or print a copy of any portion of the Content
            for personal, non-commercial use or internal business purpose.
          </p>
          <p>
            No part of the Services, Content, or Marks may be copied,
            reproduced, aggregated, republished, uploaded, posted, publicly
            displayed, encoded, translated, transmitted, distributed, sold,
            licensed, or otherwise exploited for any commercial purpose without
            our express prior written permission.
          </p>
          <p>
            If you wish to make any use of the Services, Content, or Marks other
            than as set out in this section, please address your request to
            <span className="text-primary">
              <a href="mailto:support@factiii.com" className="hover:underline">
                {' '}
                support@factiii.com
              </a>
            </span>
            .
          </p>
          <p>
            Any breach of these Intellectual Property Rights will constitute a
            material breach of our Legal Terms and your right to use our
            Services will terminate immediately.
          </p>

          <h3 className="mb-2 text-lg font-semibold">
            Your submissions and contributions
          </h3>
          <p>
            Please review this section and the{' '}
            <span className="text-primary">
              <a href="#8" className="hover:underline">
                PROHIBITED ACTIVITIES
              </a>{' '}
            </span>
            section carefully before using our Services to understand the rights
            you give us and obligations you have when you post or upload any
            content.
          </p>
          <p>
            By directly sending us any question, comment, suggestion, idea,
            feedback, or other information about the Services
            (&quot;Submissions&quot;), you agree to assign to us all
            intellectual property rights in such Submission. We shall own this
            Submission and be entitled to its unrestricted use and dissemination
            for any lawful purpose without acknowledgment or compensation to
            you.
          </p>
          <p>
            The Services may invite you to chat, contribute to, or participate
            in blogs, message boards, online forums, and other functionality
            where you may create, submit, post, display, transmit, publish,
            distribute, or broadcast content and materials to us or through the
            Services, including text, writings, video, audio, photographs,
            music, graphics, comments, reviews, rating suggestions, personal
            information, or other material (&quot;Contributions&quot;).
          </p>
          <p>
            You understand that Contributions may be viewable by other users of
            the Services and possibly through third-party websites.
          </p>
          <p>
            By posting Contributions, you grant us an unrestricted, unlimited,
            irrevocable, perpetual, non-exclusive, transferable, royalty-free,
            fully-paid, worldwide right, and license to use, copy, reproduce,
            distribute, sell, resell, publish, broadcast, retitle, store,
            publicly perform, publicly display, reformat, translate, excerpt (in
            whole or in part), and exploit your Contributions for any purpose,
            commercial, advertising, or otherwise.
          </p>
          <p>
            This license includes our use of your name, company name, and
            franchise name, as applicable, and any of the trademarks, service
            marks, trade names, logos, and personal and commercial images you
            provide.
          </p>
          <p>
            You are responsible for what you post or upload. By sending us
            Submissions and/or posting Contributions through any part of the
            Services, you confirm that you have read and agree with our{' '}
            <span className="text-primary">
              <a href="#8" className="text-primary hover:underline">
                PROHIBITED ACTIVITIES
              </a>
            </span>{' '}
            and will not post, send, publish, upload, or transmit any Submission
            or Contribution that is illegal, harassing, hateful, harmful,
            defamatory, obscene, bullying, abusive, discriminatory, threatening
            to any person or group, sexually explicit, false, inaccurate,
            deceitful, or misleading.
          </p>
          <p>
            We may remove or edit your Content at any time without notice if we
            consider such Contributions harmful or in breach of these Legal
            Terms. If we remove or edit any such Contributions, we may also
            suspend or disable your account and report you to the authorities.
          </p>

          <h3 className="mb-2 text-lg font-semibold">Copyright infringement</h3>
          <p>
            We respect the intellectual property rights of others. If you
            believe that any material available on or through the Services
            infringes upon any copyright you own or control, please immediately
            refer to the{' '}
            <span className="text-primary">
              <a href="#18" className=" hover:underline">
                COPYRIGHT INFRINGEMENTS
              </a>
            </span>{' '}
            section below.
          </p>
        </section>

        <section>
          <h2 id="3" className="mb-2 text-xl font-semibold">
            3. USER REPRESENTATIONS
          </h2>
          <p className="mb-4">
            By using the Services, you represent and warrant that: (1) all
            registration information you submit will be true, accurate, current,
            and complete; (2) you will maintain the accuracy of such information
            and promptly update such registration information as necessary; (3)
            you have the legal capacity and you agree to comply with these Legal
            Terms; (4) you are not under the age of 13; (5) you are not a minor
            in the jurisdiction in which you reside, or if a minor, you have
            received parental permission to use the Services; (6) you will not
            access the Services through automated or non-human means, whether
            through a bot, script or otherwise; (7) you will not use the
            Services for any illegal or unauthorized purpose; and (8) your use
            of the Services will not violate any applicable law or regulation.
          </p>
          <p className="mb-4">
            If you provide any information that is untrue, inaccurate, not
            current, or incomplete, we have the right to suspend or terminate
            your account and refuse any and all current or future use of the
            Services (or any portion thereof).
          </p>
        </section>

        <section>
          <h2 id="4" className="mb-2 text-xl font-semibold">
            4. USER REGISTRATION
          </h2>
          <p className="mb-4">
            You may be required to register to use the Services. You agree to
            keep your password confidential and will be responsible for all use
            of your account and password. We reserve the right to remove,
            reclaim, or change a username you select if we determine, in our
            sole discretion, that such username is inappropriate, obscene, or
            otherwise objectionable.
          </p>
        </section>

        <section>
          <h2 id="5" className="mb-2 text-xl font-semibold">
            5. PRODUCTS
          </h2>
          <p className="mb-4">
            We make every effort to display as accurately as possible the
            colors, features, specifications, and details of the products
            available on the Services. However, we do not guarantee that the
            colors, features, specifications, and details of the products will
            be accurate, complete, reliable, current, or free of other errors,
            and your electronic display may not accurately reflect the actual
            colors and details of the products. All products are subject to
            availability, and we cannot guarantee that items will be in stock.
            We reserve the right to discontinue any products at any time for any
            reason. Prices for all products are subject to change.
          </p>
        </section>

        <section>
          <h2 id="6" className="mb-2 text-xl font-semibold">
            6. PURCHASES AND PAYMENT
          </h2>
          <p className="mb-4">We accept the following forms of payment:</p>
          <ul className="mb-4 list-disc pl-6">
            <li>Visa</li>
            <li>Mastercard</li>
            <li>American Express</li>
            <li>PayPal</li>
          </ul>
          <p className="mb-4">
            You agree to provide current, complete, and accurate purchase and
            account information for all purchases made via the Services. You
            further agree to promptly update account and payment information,
            including email address, payment method, and payment card expiration
            date, so that we can complete your transactions and contact you as
            needed. Sales tax will be added to the price of purchases as deemed
            required by us. We may change prices at any time. All payments shall
            be in US dollars.
          </p>
          <p className="mb-4">
            You agree to pay all charges at the prices then in effect for your
            purchases and any applicable shipping fees, and you authorize us to
            charge your chosen payment provider for any such amounts upon
            placing your order. We reserve the right to correct any errors or
            mistakes in pricing, even if we have already requested or received
            payment.
          </p>
          <p className="mb-4">
            We reserve the right to refuse any order placed through the
            Services. We may, in our sole discretion, limit or cancel quantities
            purchased per person, per household, or per order. These
            restrictions may include orders placed by or under the same customer
            account, the same payment method, and/or orders that use the same
            billing or shipping address. We reserve the right to limit or
            prohibit orders that, in our sole judgment, appear to be placed by
            dealers, resellers, or distributors.
          </p>
        </section>

        <section>
          <h2 id="7" className="mb-2 text-xl font-semibold">
            7. RETURN/REFUNDS POLICY
          </h2>
          <p className="mb-4">
            All sales are final and no refund will be issued.
          </p>
        </section>

        <section>
          <h2 id="8" className="mb-2 text-xl font-semibold">
            8. PROHIBITED ACTIVITIES
          </h2>
          <p className="mb-4">
            You may not access or use the Services for any purpose other than
            that for which we make the Services available. The Services may not
            be used in connection with any commercial endeavors except those
            that are specifically endorsed or approved by us.
          </p>
          <p className="mb-4">As a user of the Services, you agree not to:</p>
          <ul className="mb-4 list-disc pl-6">
            <li>
              Systematically retrieve data or other content from the Services to
              create or compile, directly or indirectly, a collection,
              compilation, database, or directory without written permission
              from us.
            </li>
            <li>
              Trick, defraud, or mislead us and other users, especially in any
              attempt to learn sensitive account information such as user
              passwords.
            </li>
            <li>
              Circumvent, disable, or otherwise interfere with security-related
              features of the Services, including features that prevent or
              restrict the use or copying of any Content or enforce limitations
              on the use of the Services and/or the Content contained therein.
            </li>
            <li>
              Disparage, tarnish, or otherwise harm, in our opinion, us and/or
              the Services.
            </li>
            <li>
              Use any information obtained from the Services in order to harass,
              abuse, or harm another person.
            </li>
            <li>
              Make improper use of our support services or submit false reports
              of abuse or misconduct.
            </li>
            <li>
              Use the Services in a manner inconsistent with any applicable laws
              or regulations.
            </li>
            <li>
              Engage in unauthorized framing of or linking to the Services.
            </li>
            <li>
              Upload or transmit (or attempt to upload or to transmit) viruses,
              Trojan horses, or other material, including excessive use of
              capital letters and spamming, that interferes with any
              party&apos;s uninterrupted use and enjoyment of the Services or
              modifies, impairs, disrupts, alters, or interferes with the use,
              features, functions, operation, or maintenance of the Services.
            </li>
            <li>
              Engage in any automated use of the system, such as using scripts
              to send comments or messages, or using any data mining, robots, or
              similar data gathering and extraction tools.
            </li>
            <li>
              Delete the copyright or other proprietary rights notice from any
              Content.
            </li>
            <li>
              Attempt to impersonate another user or person or use the username
              of another user.
            </li>
            <li>
              Upload or transmit (or attempt to upload or to transmit) any
              material that acts as a passive or active information collection
              or transmission mechanism.
            </li>
            <li>
              Interfere with, disrupt, or create an undue burden on the Services
              or the networks or services connected to the Services.
            </li>
            <li>
              Harass, annoy, intimidate, or threaten any of our employees or
              agents engaged in providing any portion of the Services to you.
            </li>
            <li>
              Attempt to bypass any measures of the Services designed to prevent
              or restrict access to the Services, or any portion of the
              Services.
            </li>
            <li>
              Copy or adapt the Services&apos; software, including but not
              limited to HTML, JavaScript, or other code.
            </li>
            <li>
              Except as permitted by applicable law, decipher, decompile,
              disassemble, or reverse engineer any of the software comprising or
              in any way making up a part of the Services.
            </li>
            <li>
              Except as may be the result of standard search engine or Internet
              browser usage, use, launch, develop, or distribute any automated
              system, including without limitation, any spider, robot, cheat
              utility, scraper, or offline reader that accesses the Services.
            </li>
            <li>
              Use a buying agent or purchasing agent to make purchases on the
              Services.
            </li>
            <li>
              Make any unauthorized use of the Services, including collecting
              usernames and/or email addresses of users by electronic or other
              means for the purpose of sending unsolicited email, or creating
              user accounts by automated means or under false pretenses.
            </li>
            <li>
              Use the Services as part of any effort to compete with us or
              otherwise use the Services and/or the Content for any
              revenue-generating endeavor or commercial enterprise.
            </li>
            <li>Sell or otherwise transfer your profile.</li>
          </ul>
        </section>

        <section>
          <h2 id="9" className="mb-2 text-xl font-semibold">
            9. USER GENERATED CONTRIBUTIONS
          </h2>
          <p className="mb-4">
            The Services may invite you to chat, contribute to, or participate
            in blogs, message boards, online forums, and other functionality,
            and may provide you with the opportunity to create, submit, post,
            display, transmit, perform, publish, distribute, or broadcast
            content and materials to us or on the Services, including but not
            limited to text, writings, video, audio, photographs, graphics,
            comments, suggestions, or personal information or other material
            (collectively, &quot;Contributions&quot;). Contributions may be
            viewable by other users of the Services and through third-party
            websites. As such, any Contributions you transmit may be treated as
            non-confidential and non-proprietary.
          </p>
          <p className="mb-4">
            When you create or make available any Contributions, you thereby
            represent and warrant that the content does not infringe any
            third-party rights, is not false or misleading, does not violate any
            applicable law, and complies with our{' '}
            <span className="text-primary">
              <a href="/aup" className="hover:underline">
                Acceptable Use Policy
              </a>
            </span>
            .
          </p>
        </section>

        <section>
          <h2 id="10" className="mb-2 text-xl font-semibold">
            10. CONTRIBUTION LICENSE
          </h2>
          <p className="mb-4">
            By posting your Contributions to any part of the Services, you
            automatically grant, and you represent and warrant that you have the
            right to grant, to us an unrestricted, unlimited, irrevocable,
            perpetual, non-exclusive, transferable, royalty-free, fully-paid,
            worldwide right, and license to host, use, copy, reproduce,
            disclose, sell, resell, publish, broadcast, retitle, archive, store,
            cache, publicly perform, publicly display, reformat, translate,
            transmit, excerpt (in whole or in part), and distribute such
            Contributions for any purpose, commercial, advertising, or
            otherwise, and to prepare derivative works of, or incorporate in
            other works, such Contributions, and grant and authorize sublicenses
            of the foregoing.
          </p>
          <p className="mb-4">
            This license will apply to any form, media, or technology now known
            or hereafter developed, and includes our use of your name, company
            name, and franchise name, as applicable, and any of the trademarks,
            service marks, trade names, logos, and personal and commercial
            images you provide.
          </p>
          <p className="mb-4">
            We do not assert any ownership over your Contributions. You retain
            full ownership of all of your Contributions and any intellectual
            property rights or other proprietary rights associated with your
            Contributions. We are not liable for any statements or
            representations in your Contributions provided by you in any area on
            the Services. You are solely responsible for your Contributions to
            the Services and you expressly agree to exonerate us from any and
            all responsibility and to refrain from any legal action against us
            regarding your Contributions.
          </p>
        </section>

        <section>
          <h2 id="11" className="mb-2 text-xl font-semibold">
            11. GUIDELINES FOR REVIEWS
          </h2>
          <p className="mb-4">
            We may provide you areas on the Services to leave reviews or
            ratings. When posting a review, you must comply with the following
            criteria: (1) you should have firsthand experience with the
            person/entity being reviewed; (2) your reviews should not contain
            offensive profanity, or abusive, racist, offensive, or hateful
            language; (3) your reviews should not contain discriminatory
            references based on religion, race, gender, national origin, age,
            marital status, sexual orientation, or disability; (4) your reviews
            should not contain references to illegal activity; (5) you should
            not be affiliated with competitors if posting negative reviews; (6)
            you should not make any conclusions as to the legality of conduct;
            (7) you may not post any false or misleading statements; and (8) you
            may not organize a campaign encouraging others to post reviews,
            whether positive or negative.
          </p>
          <p className="mb-4">
            We may accept, reject, or remove reviews in our sole discretion. We
            have absolutely no obligation to screen reviews or to delete
            reviews, even if anyone considers reviews objectionable or
            inaccurate. Reviews are not endorsed by us, and do not necessarily
            represent our opinions or the views of any of our affiliates or
            partners. We do not assume liability for any review or for any
            claims, liabilities, or losses resulting from any review.
          </p>
        </section>

        <section>
          <h2 id="12" className="mb-2 text-xl font-semibold">
            12. MOBILE APPLICATION LICENSE
          </h2>
          <h3 className="mb-2 text-lg font-semibold">Use License</h3>
          <p className="mb-4">
            If you access the Services via the App, then we grant you a
            revocable, non-exclusive, non-transferable, limited right to install
            and use the App on wireless electronic devices owned or controlled
            by you, and to access and use the App on such devices strictly in
            accordance with the terms and conditions of this mobile application
            license contained in these Legal Terms. You shall not: (1)
            decompile, reverse engineer, disassemble, attempt to derive the
            source code of, or decrypt the App; (2) make any modification,
            adaptation, improvement, enhancement, translation, or derivative
            work from the App; (3) violate any applicable laws, rules, or
            regulations in connection with your access or use of the App; (4)
            remove, alter, or obscure any proprietary notice posted by us or the
            licensors of the App; (5) use the App for any revenue-generating
            endeavor, commercial enterprise, or other purpose for which it is
            not designed or intended; (6) make the App available over a network
            or other environment permitting access or use by multiple devices or
            users at the same time; (7) use the App for creating a product,
            service, or software that is, directly or indirectly, competitive
            with or in any way a substitute for the App; (8) use the App to send
            automated queries to any website or to send any unsolicited
            commercial email; or (9) use any proprietary information or any of
            our interfaces or our other intellectual property in the design,
            development, manufacture, licensing, or distribution of any
            applications, accessories, or devices for use with the App.
          </p>
          <h3 className="mb-2 text-lg font-semibold">
            Apple and Android Devices
          </h3>
          <p className="mb-4">
            The following terms apply when you use the App obtained from either
            the Apple Store or Google Play to access the Services: (1) the
            license granted to you for our App is limited to a non-transferable
            license to use the application on a device that utilizes the Apple
            iOS or Android operating systems, as applicable, and in accordance
            with the usage rules set forth in the applicable app
            distributor&apos;s terms of service; (2) we are responsible for
            providing any maintenance and support services with respect to the
            App as specified in the terms and conditions of this mobile
            application license contained in these Legal Terms or as otherwise
            required under applicable law, and you acknowledge that each app
            distributor has no obligation whatsoever to furnish any maintenance
            and support services with respect to the App; (3) in the event of
            any failure of the App to conform to any applicable warranty, you
            may notify the applicable app distributor, and the app distributor,
            in accordance with its terms and policies, may refund the purchase
            price, if any, paid for the App; (4) you represent and warrant that
            (i) you are not located in a country that is subject to a US
            Government embargo, or that has been designated by the US Government
            as a &quot;terrorist supporting&quot; country and (ii) you are not
            listed on any US Government list of prohibited or restricted
            parties; (5) you must comply with applicable third-party terms of
            agreement when using the App; and (6) you acknowledge and agree that
            the app distributors are third-party beneficiaries of the terms and
            conditions in this mobile application license contained in these
            Legal Terms, and that each app distributor will have the right (and
            will be deemed to have accepted the right) to enforce the terms and
            conditions in this mobile application license contained in these
            Legal Terms against you as a third-party beneficiary thereof.
          </p>
          <p className="mb-4">
            If you enable health tracking features in the App, any health data
            accessed through HealthKit or Health Connect is used to provide
            health, motion, and fitness features that are evident in the App,
            including on-device analytics that help you understand how your
            activity patterns relate to your use of the Services. That data is
            handled in accordance with our Privacy Policy and End User License
            Agreement.
          </p>
        </section>

        <section>
          <h2 id="13" className="mb-2 text-xl font-semibold">
            13. SOCIAL MEDIA
          </h2>
          <p className="mb-4">
            As part of the functionality of the Services, you may link your
            account with online accounts you have with third-party service
            providers (each such account, a &quot;Third-Party Account&quot;) by
            either: (1) providing your Third-Party Account login information
            through the Services; or (2) allowing us to access your Third-Party
            Account, as is permitted under the applicable terms and conditions
            that govern your use of each Third-Party Account. You represent and
            warrant that you are entitled to disclose your Third-Party Account
            login information to us and/or grant us access to your Third-Party
            Account, without breach by you of any of the terms and conditions
            that govern your use of the applicable Third-Party Account, and
            without obligating us to pay any fees or making us subject to any
            usage limitations imposed by the third-party service provider of the
            Third-Party Account.
          </p>
        </section>

        <section>
          <h2 id="14" className="mb-2 text-xl font-semibold">
            14. THIRD-PARTY WEBSITES AND CONTENT
          </h2>
          <p className="mb-4">
            The Services may contain (or you may be sent via the App) links to
            other websites (&quot;Third-Party Websites&quot;) as well as
            articles, photographs, text, graphics, pictures, designs, music,
            sound, video, information, applications, software, and other content
            or items belonging to or originating from third parties
            (&quot;Third-Party Content&quot;). Such Third-Party Websites and
            Third-Party Content are not investigated, monitored, or checked for
            accuracy, appropriateness, or completeness by us, and we are not
            responsible for any Third-Party Websites accessed through the
            Services or any Third-Party Content posted on, available through, or
            installed from the Services, including the content, accuracy,
            offensiveness, opinions, reliability, privacy practices, or other
            policies of or contained in the Third-Party Websites or the
            Third-Party Content.
          </p>
        </section>

        <section>
          <h2 id="15" className="mb-2 text-xl font-semibold">
            15. ADVERTISERS
          </h2>
          <p className="mb-4">
            We allow advertisers to display their advertisements and other
            information in certain areas of the Services, such as sidebar
            advertisements or banner advertisements. We simply provide the space
            to place such advertisements, and we have no other relationship with
            advertisers.
          </p>
        </section>

        <section>
          <h2 id="16" className="mb-2 text-xl font-semibold">
            16. SERVICES MANAGEMENT
          </h2>
          <p className="mb-4">
            We reserve the right, but not the obligation, to: (1) monitor the
            Services for violations of these Legal Terms; (2) take appropriate
            legal action against anyone who, in our sole discretion, violates
            the law or these Legal Terms, including without limitation,
            reporting such user to law enforcement authorities; (3) in our sole
            discretion and without limitation, refuse, restrict access to, limit
            the availability of, or disable (to the extent technologically
            feasible) any of your Contributions or any portion thereof; (4) in
            our sole discretion and without limitation, notice, or liability, to
            remove from the Services or otherwise disable all files and content
            that are excessive in size or are in any way burdensome to our
            systems; and (5) otherwise manage the Services in a manner designed
            to protect our rights and property and to facilitate the proper
            functioning of the Services.
          </p>
        </section>

        <section>
          <h2 id="17" className="mb-2 text-xl font-semibold">
            17. PRIVACY POLICY
          </h2>
          <p className="mb-4">
            We care about data privacy and security. Please review our Privacy
            Policy:{' '}
            <span className="text-primary">
              <a href="/privacy" className="hover:underline">
                {process.env.NEXT_PUBLIC_SITE_URL}/privacy
              </a>
            </span>
            . By using the Services, you agree to be bound by our Privacy
            Policy, which is incorporated into these Legal Terms. Please be
            advised the Services are hosted in the United States. If you access
            the Services from any other region of the world with laws or other
            requirements governing personal data collection, use, or disclosure
            that differ from applicable laws in the United States, then through
            your continued use of the Services, you are transferring your data
            to the United States, and you expressly consent to have your data
            transferred to and processed in the United States.
          </p>
        </section>

        <section>
          <h2 id="18" className="mb-2 text-xl font-semibold">
            18. COPYRIGHT INFRINGEMENTS
          </h2>
          <p className="mb-4">
            We respect the intellectual property rights of others. If you
            believe that any material available on or through the Services
            infringes upon any copyright you own or control, please immediately
            notify us using the contact information provided below (a
            &quot;Notification&quot;). A copy of your Notification will be sent
            to the person who posted or stored the material addressed in the
            Notification. Please be advised that pursuant to applicable law you
            may be held liable for damages if you make material
            misrepresentations in a Notification. Thus, if you are not sure that
            material located on or linked to by the Services infringes your
            copyright, you should consider first contacting an attorney.
          </p>
        </section>

        <section>
          <h2 id="19" className="mb-2 text-xl font-semibold">
            19. TERM AND TERMINATION
          </h2>
          <p className="mb-4">
            These Legal Terms shall remain in full force and effect while you
            use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
            LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
            WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES
            (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY
            REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF
            ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE LEGAL
            TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR
            USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR ACCOUNT AND ANY
            CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING,
            IN OUR SOLE DISCRETION.
          </p>
          <p className="mb-4">
            If we terminate or suspend your account for any reason, you are
            prohibited from registering and creating a new account under your
            name, a fake or borrowed name, or the name of any third party, even
            if you may be acting on behalf of the third party. In addition to
            terminating or suspending your account, we reserve the right to take
            appropriate legal action, including without limitation pursuing
            civil, criminal, and injunctive redress.
          </p>
        </section>

        <section>
          <h2 id="20" className="mb-2 text-xl font-semibold">
            20. MODIFICATIONS AND INTERRUPTIONS
          </h2>
          <p className="mb-4">
            We reserve the right to change, modify, or remove the contents of
            the Services at any time or for any reason at our sole discretion
            without notice. However, we have no obligation to update any
            information on our Services. We also reserve the right to modify or
            discontinue all or part of the Services without notice at any time.
            We will not be liable to you or any third party for any
            modification, price change, suspension, or discontinuance of the
            Services.
          </p>
          <p className="mb-4">
            We cannot guarantee the Services will be available at all times. We
            may experience hardware, software, or other problems or need to
            perform maintenance related to the Services, resulting in
            interruptions, delays, or errors. We reserve the right to change,
            revise, update, suspend, discontinue, or otherwise modify the
            Services at any time or for any reason without notice to you. You
            agree that we have no liability whatsoever for any loss, damage, or
            inconvenience caused by your inability to access or use the Services
            during any downtime or discontinuance of the Services.
          </p>
        </section>

        <section>
          <h2 id="21" className="mb-2 text-xl font-semibold">
            21. GOVERNING LAW
          </h2>
          <p className="mb-4">
            These Legal Terms shall be governed by and defined following the
            laws of the State of Texas. factiii limited liability company and
            yourself irrevocably consent that the courts of Texas shall have
            exclusive jurisdiction to resolve any dispute which may arise in
            connection with these Legal Terms.
          </p>
        </section>

        <section>
          <h2 id="22" className="mb-2 text-xl font-semibold">
            22. DISPUTE RESOLUTION
          </h2>
          <h3 className="mb-2 text-lg font-semibold">Informal Negotiations</h3>
          <p className="mb-4">
            To expedite resolution and control the cost of any dispute,
            controversy, or claim related to these Legal Terms (each a
            &quot;Dispute&quot; and collectively, the &quot;Disputes&quot;)
            brought by either you or us (individually, a &quot;Party&quot; and
            collectively, the &quot;Parties&quot;), the Parties agree to first
            attempt to negotiate any Dispute (except those Disputes expressly
            provided below) informally for at least thirty (30) days before
            initiating arbitration. Such informal negotiations commence upon
            written notice from one Party to the other Party.
          </p>
          <h3 className="mb-2 text-lg font-semibold">Binding Arbitration</h3>
          <p className="mb-4">
            Any dispute arising out of or in connection with these Legal Terms,
            including any question regarding its existence, validity, or
            termination, shall be referred to and finally resolved by the
            International Commercial Arbitration Court under the European
            Arbitration Chamber (Belgium, Brussels, Avenue Louise, 146)
            according to the Rules of this ICAC, which, as a result of referring
            to it, is considered as the part of this clause. The number of
            arbitrators shall be one (1). The seat, or legal place, of
            arbitration shall be San Antonio, Texas. The language of the
            proceedings shall be English. The governing law of these Legal Terms
            shall be substantive law of the State of Texas.
          </p>
          <h3 className="mb-2 text-lg font-semibold">Restrictions</h3>
          <p className="mb-4">
            The Parties agree that any arbitration shall be limited to the
            Dispute between the Parties individually. To the full extent
            permitted by law, (a) no arbitration shall be joined with any other
            proceeding; (b) there is no right or authority for any Dispute to be
            arbitrated on a class-action basis or to utilize class action
            procedures; and (c) there is no right or authority for any Dispute
            to be brought in a purported representative capacity on behalf of
            the general public or any other persons.
          </p>
          <h3 className="mb-2 text-lg font-semibold">
            Exceptions to Informal Negotiations and Arbitration
          </h3>
          <p className="mb-4">
            The Parties agree that the following Disputes are not subject to the
            above provisions concerning informal negotiations binding
            arbitration: (a) any Disputes seeking to enforce or protect, or
            concerning the validity of, any of the intellectual property rights
            of a Party; (b) any Dispute related to, or arising from, allegations
            of theft, piracy, invasion of privacy, or unauthorized use; and (c)
            any claim for injunctive relief. If this provision is found to be
            illegal or unenforceable, then neither Party will elect to arbitrate
            any Dispute falling within that portion of this provision found to
            be illegal or unenforceable and such Dispute shall be decided by a
            court of competent jurisdiction within the courts listed for
            jurisdiction above, and the Parties agree to submit to the personal
            jurisdiction of that court.
          </p>
        </section>

        <section>
          <h2 id="23" className="mb-2 text-xl font-semibold">
            23. CORRECTIONS
          </h2>
          <p className="mb-4">
            There may be information on the Services that contains typographical
            errors, inaccuracies, or omissions, including descriptions, pricing,
            availability, and various other information. We reserve the right to
            correct any errors, inaccuracies, or omissions and to change or
            update the information on the Services at any time, without prior
            notice.
          </p>
        </section>

        <section>
          <h2 id="24" className="mb-2 text-xl font-semibold">
            24. DISCLAIMER
          </h2>
          <p className="mb-4">
            THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
            AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO
            THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
            EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
            THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
            NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE
            ACCURACY OR COMPLETENESS OF THE SERVICES&apos; CONTENT OR THE
            CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE
            SERVICES AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY
            (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2)
            PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
            RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY
            UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND
            ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
            THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
            FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE
            WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD
            PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND
            MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT
            OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE
            AVAILABLE VIA THE SERVICES. WE DO NOT WARRANT, ENDORSE, GUARANTEE,
            OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR
            OFFERED BY A THIRD PARTY THROUGH THE SERVICES, ANY HYPERLINKED
            WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER
            OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE
            RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY
            THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.
          </p>
        </section>

        <section>
          <h2 id="25" className="mb-2 text-xl font-semibold">
            25. LIMITATIONS OF LIABILITY
          </h2>
          <p className="mb-4">
            IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE
            TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,
            EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST
            PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM
            YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE
            CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE
            WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL
            TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO US DURING THE
            SIX (6) MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING. CERTAIN
            US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON
            IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN
            DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
            DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE
            ADDITIONAL RIGHTS.
          </p>
        </section>

        <section>
          <h2 id="26" className="mb-2 text-xl font-semibold">
            26. INDEMNIFICATION
          </h2>
          <p className="mb-4">
            You agree to defend, indemnify, and hold us harmless, including our
            subsidiaries, affiliates, and all of our respective officers,
            agents, partners, and employees, from and against any loss, damage,
            liability, claim, or demand, including reasonable attorneys&apos;
            fees and expenses, made by any third party due to or arising out of:
            (1) your Contributions; (2) use of the Services; (3) breach of these
            Legal Terms; (4) any breach of your representations and warranties
            set forth in these Legal Terms; (5) your violation of the rights of
            a third party, including but not limited to intellectual property
            rights; or (6) any overt harmful act toward any other user of the
            Services with whom you connected via the Services. Notwithstanding
            the foregoing, we reserve the right, at your expense, to assume the
            exclusive defense and control of any matter for which you are
            required to indemnify us, and you agree to cooperate, at your
            expense, with our defense of such claims. We will use reasonable
            efforts to notify you of any such claim, action, or proceeding which
            is subject to this indemnification upon becoming aware of it.
          </p>
        </section>

        <section>
          <h2 id="27" className="mb-2 text-xl font-semibold">
            27. USER DATA
          </h2>
          <p className="mb-4">
            We will maintain certain data that you transmit to the Services for
            the purpose of managing the performance of the Services, as well as
            data relating to your use of the Services. Although we perform
            regular routine backups of data, you are solely responsible for all
            data that you transmit or that relates to any activity you have
            undertaken using the Services. You agree that we shall have no
            liability to you for any loss or corruption of any such data, and
            you hereby waive any right of action against us arising from any
            such loss or corruption of such data.
          </p>
        </section>

        <section>
          <h2 id="28" className="mb-2 text-xl font-semibold">
            28. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
          </h2>
          <p className="mb-4">
            Visiting the Services, sending us emails, and completing online
            forms constitute electronic communications. You consent to receive
            electronic communications, and you agree that all agreements,
            notices, disclosures, and other communications we provide to you
            electronically, via email and on the Services, satisfy any legal
            requirement that such communication be in writing. YOU HEREBY AGREE
            TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER
            RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND
            RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE
            SERVICES.
          </p>
        </section>

        <section>
          <h2 id="29" className="mb-2 text-xl font-semibold">
            29. CALIFORNIA USERS AND RESIDENTS
          </h2>
          <p className="mb-4">
            If any complaint with us is not satisfactorily resolved, you can
            contact the Complaint Assistance Unit of the Division of Consumer
            Services of the California Department of Consumer Affairs in writing
            at 1625 North Market Blvd., Suite N 112, Sacramento, California
            95834 or by telephone at (800) 952-5210 or (916) 445-1254.
          </p>
        </section>

        <section>
          <h2 id="30" className="mb-2 text-xl font-semibold">
            30. MISCELLANEOUS
          </h2>
          <p className="mb-4">
            These Legal Terms and any policies or operating rules posted by us
            on the Services or in respect to the Services constitute the entire
            agreement and understanding between you and us. Our failure to
            exercise or enforce any right or provision of these Legal Terms
            shall not operate as a waiver of such right or provision. These
            Legal Terms operate to the fullest extent permissible by law. We may
            assign any or all of our rights and obligations to others at any
            time. We shall not be responsible or liable for any loss, damage,
            delay, or failure to act caused by any cause beyond our reasonable
            control. If any provision or part of a provision of these Legal
            Terms is determined to be unlawful, void, or unenforceable, that
            provision or part of the provision is deemed severable from these
            Legal Terms and does not affect the validity and enforceability of
            any remaining provisions. There is no joint venture, partnership,
            employment or agency relationship created between you and us as a
            result of these Legal Terms or use of the Services. You agree that
            these Legal Terms will not be construed against us by virtue of
            having drafted them. You hereby waive any and all defenses you may
            have based on the electronic form of these Legal Terms and the lack
            of signing by the parties hereto to execute these Legal Terms.
          </p>
        </section>

        <section>
          <h2 id="31" className="mb-2 text-xl font-semibold">
            31. CONTACT US
          </h2>
          <p>
            To resolve a complaint regarding the Services or to receive further
            information regarding use of the Services, please contact us at:
          </p>
          <address className="not-italic">
            <p>factiii limited liability company</p>
            <p>San Antonio, TX 78254</p>
            <p>United States</p>
            <p>
              <span className="text-primary">
                <a
                  href="mailto:support@factiii.com"
                  className="text-primary hover:underline"
                >
                  support@factiii.com
                </a>
              </span>
            </p>
          </address>
        </section>
      </div>
    </AppLayout>
  );
};

export default Terms;
